import { ReactElement } from "react"

import { UseQueryResult } from "@tanstack/react-query"

import { Spinner } from "@/components/ui/Spinner"
import { ErrorState } from "@/src/components"

export function Loader<TData, TError>({
  result,
  render,
}: {
  result: UseQueryResult<TData, TError>
  render: (props: { data: TData }) => ReactElement | null
}) {
  const { data, isLoading, error } = result
  if (error)
    return <ErrorState title={"Hit an error while fetching data"} rawError={error} />
  if (isLoading) return <Spinner className="m-4" />
  if (!data) return <>No data 🫠</>

  return render({ data })
}
